<template>
  <div>
    <digital-report-response
      v-if="selectedChannel === 'digital-report'"
      :followup-url="followupUrl"
      :organization-full-name="organizationFullName"
      :organization-name="organizationName"
      :email="email"
      :case-name="caseName"
      :password="password"
      :locale="locale"
      :feature-name="featureName"
    />
    <physical-meeting-response
      v-if="selectedChannel === 'physical-meeting'"
      :followup-url="followupUrl"
      :organization-full-name="organizationFullName"
      :organization-name="organizationName"
      :email="email"
      :case-name="caseName"
      :password="password"
      :locale="locale"
      :feature-name="featureName"
    />
    <phone-call-response
      v-if="selectedChannel === 'phone-call'"
      :followup-url="followupUrl"
      :organization-full-name="organizationFullName"
      :organization-name="organizationName"
      :email="email"
      :case-name="caseName"
      :password="password"
      :locale="locale"
      :feature-name="featureName"
    />
  </div>
</template>

<script>
import DevOps from '@puls-solutions/puls-devops-utils'
import LocalizableComponent from './LocalizableComponent.vue'
import DigitalReportResponse from './DigitalReportResponse.vue'
import PhysicalMeetingResponse from './PhysicalMeetingResponse.vue'
import PhoneCallResponse from './PhoneCallResponse.vue'
import config from '../config'

const c = DevOps.WebApp.configToUse({ config })

export default {
  name: 'CreateReportResponse',
  components: {
    DigitalReportResponse,
    PhysicalMeetingResponse,
    PhoneCallResponse
  },
  extends: LocalizableComponent,
  props: {
    organizationName: {
      type: String,
      default: 'abc',
      required: true
    },
    organizationFullName: {
      type: String,
      default: ''
    },
    caseName: {
      type: String,
      required: true
    },
    password: {
      type: String,
      default: 'abc',
      required: true
    },
    email: {
      type: String,
      default: null,
      required: false
    },
    locale: {
      type: String,
      default: null,
      required: false
    },
    selectedChannel: {
      type: String,
      default: null,
      required: true
    },
    featureName: {
      type: String,
      default: ''
    }
  },
  computed: {
    followupUrl() {
      const host =
        c.env === 'dev' || c.env === 'staging'
          ? 'pulsmeter.net'
          : 'puls-solutions.com'
      return `https://${c.env}.${host}/reporter/#/followup?o=${this.organizationName}&l=${this.locale}`
    }
  }
}
</script>

<style scoped></style>
